<p-accordion>
    <p-accordionTab header="Category">
      <p-table [value]="categories" [scrollable]="true" scrollHeight="180px" [reorderableColumns]="true"
        dataKey="name">
        <ng-template pTemplate="header">
          <tr>
            <th style="max-width:3rem"></th>
            <th class="p-col-10" pReorderableColumn>Name</th>
            <!-- <th class="p-col-2" pReorderableColumn>Action</th> -->
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-index="rowIndex" let-expanded="expanded">
          <tr [pReorderableRow]="index" style="cursor: move;">
            <td class="p-col-10" pReorderableRowHandle>{{data.name}}</td>
            <td class="p-col-2 action" pReorderableRowHandle>
              <span class="btnBars p-mr-0" *ngIf="data.organizationId!=0" (click)="showEditCategory(data)"
                pTooltip="Edit" tooltipPosition="top"><i class="pi
                  pi-pencil"></i></span>
              <!-- <span class="btnBars p-mr-0" (click)="checkCategory(data)" pTooltip="Delete"
                tooltipPosition="top"><i class="pi pi-trash"></i></span> -->
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-accordionTab>
  </p-accordion>

  <p-dialog header="{{addEditFieldHeader}}" [modal]="true" [(visible)]="displayAddEditFieldData"
    [style]="{width: '50vw'}" [baseZIndex]="10000" (onHide)="fieldForm.reset();invalidData=false">
    <form [formGroup]="fieldForm">
      <div class="p-grid">
        <div class="p-col-12" *ngIf="addEditFieldHeader == fieldDataConstants.AddFieldTitle">
          <label for="type">Fields Type <span style="color: red;">*</span></label>
          <p-dropdown [options]="locationDataTypes" formControlName="fieldType"
            optionLabel="name"  placeholder="Select Field Type"
            appendTo="body"></p-dropdown>
        </div>
        <div class="p-col-12" *ngIf="addEditFieldHeader == fieldDataConstants.EditFieldTitle">
          <h5 class="p-mb-0">Fields Name -- {{locationTypeName}}</h5>
        </div>
        <div class="p-col-12">
          <label for="name">Name <span style="color: red;">*</span></label>
          <input type="text" pInputText formControlName="name">
          <small *ngIf="invalidData == true" class="p-invalid">
            Name exists in the list already
          </small>
        </div>
        <div class="p-col-12">
          <label for="name">Description</label>
          <input type="text" formControlName="description" pInputText style="width: 100%;">
        </div>
      </div>
    </form>

    <ng-template pTemplate="footer">
      <button pButton (click)="displayAddEditFieldData=false" label="Cancel" class="p-button-secondary"></button>
      <button pButton [disabled]="!fieldForm.valid" (click)="saveField(fieldForm.value)" label="Save"></button>
    </ng-template>
  </p-dialog>

  <p-dialog header="Delete Category" [(visible)]="displayLocationAvailability" [modal]="true" [responsive]="true"
    [style]="{width: '60vw'}">
    <div class="header">
      <h5>Delete Warning</h5>
    </div>
    <div class="card">
      <span style="font-weight: bold;">This Category is associated with below Multiple Location</span><br>
      <span>{{associatedLocations}}</span>
    </div>
  </p-dialog>

